import type { StaticPageKey } from '../../shared/content/staticPageContent.js';
import type { StaticPageBuiltInSectionKey } from '../../shared/editor/landingEditorTypes.js';
import type { LandingEditorElementDefinition } from '../editor/landingEditorRegistry.js';

export const rootSectionDefinitionFor = (
  definition: LandingEditorElementDefinition | undefined,
  definitionById: Readonly<Record<string, LandingEditorElementDefinition>>,
) => {
  let current = definition;
  while (current?.parentId && current.parentId !== 'page.root') current = definitionById[current.parentId];
  return current?.parentId === 'page.root' ? current : undefined;
};

export const revealPreviewSelectionInLayers = (
  elementId: string,
  definitionById: Readonly<Record<string, LandingEditorElementDefinition>>,
  expandedSections: Readonly<Record<string, boolean>>,
  setExpandedSections: (value: Record<string, boolean>) => void,
  setLeftTab: (value: 'layers') => void,
  setSelectedElementId: (value: string) => void,
) => {
  setLeftTab('layers');

  const nextExpandedSections = { ...expandedSections };
  let definition = definitionById[elementId];
  let changed = false;
  while (definition?.parentId && definition.parentId !== 'page.root') {
    if (nextExpandedSections[definition.parentId] === false) {
      nextExpandedSections[definition.parentId] = true;
      changed = true;
    }
    definition = definitionById[definition.parentId];
  }
  if (changed) setExpandedSections(nextExpandedSections);
  setSelectedElementId(elementId);
};

export const staticPageBuiltInSectionKeyFromDefinition = (
  pageKey: StaticPageKey | null,
  definition: LandingEditorElementDefinition | undefined,
): StaticPageBuiltInSectionKey | null => {
  if (!pageKey || !definition?.id) return null;
  const prefix = `static.${pageKey}`;
  const fixedSections: Readonly<Record<string, StaticPageBuiltInSectionKey>> = {
    [`${prefix}.hero`]: 'hero',
    [`${prefix}.missionStory`]: 'missionStory',
    [`${prefix}.cards`]: 'cards',
    [`${prefix}.globusJobs`]: 'globusJobs',
    [`${prefix}.faq`]: 'faq',
    [`${prefix}.cta`]: 'cta',
    [`${prefix}.team`]: 'team',
    [`${prefix}.contact`]: 'contact',
  };
  const fixedSection = fixedSections[definition.id];
  if (fixedSection) return fixedSection;

  const detailPrefix = `${prefix}.section.`;
  if (!definition.id.startsWith(detailPrefix)) return null;
  const index = Number(definition.id.slice(detailPrefix.length));
  return Number.isInteger(index) && index >= 0 ? (`detail:${index}` as StaticPageBuiltInSectionKey) : null;
};
